export default __webpack_public_path__ + "static/media/grandlale6.93027617.jpg";